import React, { Component } from 'react';
import {
  select,
  scaleLinear,
  scaleBand,
  axisBottom,
  axisLeft,
  min,
  max,
  formatLocale
} from 'd3';

import StyledBoxPlot from './StyledBoxPlot';

class BoxPlot extends Component {

  state = {
    width: 0,
    height: 0
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    const newData = this.props.data && this.props.data !== prevProps.data;
    const newDimensions = prevState.width !== this.state.width || prevState.height !== this.state.height;
    if (newData || newDimensions) this.updateChart();
  }

  componentWillReceiveProps(nextProps) {


    switch (nextProps.highlights[0]) {
      case 'boxplots-alle-huishoudens':
        this.highlightBox(['Alle huishoudens'])
        break;
      case 'boxplots-inkomens':
        this.highlightBox(['Laagste 20%','Van 21 tot 40%','Van 41 tot 60%','Van 61 tot 80%','Hoogste 20%'])
        break;
      case 'boxplots-inkomensbron':
        this.highlightBox(['Werkenden','Uitkeringsgerechtigden','Gepensioneerden'])
        break;
      case 'boxplots-huishouden':
        this.highlightBox(['Tweeverdieners','Alleenstaanden','Alleenverdieners'])
        break;
      case 'boxplots-gezin':
        this.highlightBox(['Met kinderen','Zonder kinderen'])
        break;
      default:
        this.highlightBox();
    }

  }

  updateDimensions = () => {
    if (!this.container) return;
    const width = this.container.clientWidth,
          height = this.props.height || this.container.clientHeight;
    if (this.state.width !== width || this.state.height !== height) this.setState({ width, height });
  }

  highlightBox = (names, showValues = false) => {
    const svg = select(this.container).select('svg');
    const boxes = svg.selectAll('.box');
    const ticks = svg.selectAll('.tick');
    const xAxis = svg.selectAll('.axis.x');
    if (names && names.length > 0) {
      boxes
        .transition()
        .style('opacity', 0.1)
      .filter(d => names.indexOf(d.name) > -1)
        .style('opacity', 1)
        .select('.af-boxplot-tooltip')
          .style('display', showValues ? 'block' : 'none');

      ticks.transition()
        .style('opacity', 0.1)
      .filter(d => names.indexOf(d) > -1)
        .style('opacity', 1)

      xAxis.transition()
        .style('opacity', 0.1)

    }
    else {
      boxes
        .transition()
        .style('opacity', 1)
        .selectAll('.af-boxplot-tooltip')
          .style('display', 'none');

      ticks.transition()
        .style('opacity', 1)

      xAxis.transition()
        .style('opacity', 1)

    }
  }

  updateChart = () => {
    const props = this.props;
    const { colorBox, colorMedian, margin, boxHeight } = props;
    const { width, height } = this.state;
    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;
    const data = props.data.filter(row => row.p5 !== undefined);

    const localeFormatter = formatLocale({
      "decimal": ",",
      "thousands": ".",
      "grouping": [3],
      "comma": true,
    });

    const svg = select(this.container).select('svg');

    const minX = min(data, d => d.p5);
    const maxX = max(data, d => d.p95);

    const domainX = props.domain ? props.domain : [minX, maxX];
    const domainY = data.map(item => item.name);

    const xScale = scaleLinear().range([0, chartWidth]).domain(domainX);
    const yScale = scaleBand().range([0, chartHeight]).domain(domainY).paddingOuter(.2);

    const xAxis = axisBottom().scale(xScale).ticks(5);
    const yAxis = axisLeft().scale(yScale).tickValues(domainY);

    const halfBandWidth = yScale.bandwidth() / 2;


    svg.select('.af-boxplot')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    svg.select('.x.axis')
      .attr('transform', 'translate(0,' + chartHeight + ')')
      .call(xAxis);

    svg.select('.axis.y')
      .call(yAxis);

    const boxes = svg.select('.af-boxplot').selectAll('.box').data(data);

    boxes
      .enter()
        .append('g')
        .attr('class', 'box')
      .merge(boxes)
      .attr('transform', d => 'translate(' + xScale(d.p50) + ',' + (yScale(d.name) + halfBandWidth)  + ')')
      .each(function(d,i){

        select(this).selectAll('*').remove();

        select(this)
          .append('line')
          .attr('class', 'range')
          .attr('x1', xScale(d.p95) - xScale(d.p50))
          .attr('x2', xScale(d.p5) - xScale(d.p50))
          .attr('y1', 0)
          .attr('y2', 0)
          .style('stroke', colorBox)
          .style('stroke-width', 2.25);

        // select(this)
        //   .append('line')
        //   .attr('class', 'max')
        //   .attr('x1', xScale(d.p95) - xScale(d.p50))
        //   .attr('x2', xScale(d.p95) - xScale(d.p50))
        //   .attr('y1', -boxHeight/2)
        //   .attr('y2', boxHeight/2)
        //   .style('stroke', colorLines)
        //   .style('stroke-width', '2');

        // select(this)
        //   .append('line')
        //   .attr('class', 'min')
        //   .attr('x1', xScale(d.p5) - xScale(d.p50))
        //   .attr('x2', xScale(d.p5) - xScale(d.p50))
        //   .attr('y1', -boxHeight/2)
        //   .attr('y2', boxHeight/2)
        //   .style('stroke', colorLines)
        //   .style('stroke-width', '2');

        select(this)
          .append('rect')
          .attr('class', 'range')
          .attr('x', xScale(d.p25) - xScale(d.p50))
          .attr('y', -boxHeight/2)
          .attr('height', boxHeight)
          .attr('width', xScale(d.p75) - xScale(d.p25))
          .style('fill', colorBox)
          // .style('stroke', colorBox)
          // .style('stroke-width', '1');

        select(this)
          .append('line')
          .attr('x1', 0)
          .attr('x2', 0)
          .attr('y1', -(boxHeight*1.5/2))
          .attr('y2', boxHeight*1.5/2)
          .style('stroke', colorMedian)
          .style('stroke-width', '5.25');

        const tooltipValues = select(this)
          .append('g')
          .style('display', 'none')
          .attr('class', 'af-boxplot-tooltip')
          .attr('fill', '#fff')
          .attr('font-size', 10)
          .attr('text-anchor', 'middle');

        tooltipValues.append('text')
          .attr('dy', -15)
          .text(localeFormatter.format(',.1f')(d.p50));

        tooltipValues.append('text')
          .attr('dx', xScale(d.p5) - xScale(d.p50))
          .attr('dy', -15)
          .text(localeFormatter.format(',.1f')(d.p5));

        tooltipValues.append('text')
          .attr('dx', xScale(d.p95) - xScale(d.p50))
          .attr('dy', -15)
          .text(localeFormatter.format(',.1f')(d.p95));

        tooltipValues.append('text')
          .attr('dx', xScale(d.p25) - xScale(d.p50))
          .attr('dy', 25)
          .text(localeFormatter.format(',.1f')(d.p25));

        tooltipValues.append('text')
          .attr('dx', xScale(d.p75) - xScale(d.p50))
          .attr('dy', 25)
          .text(localeFormatter.format(',.1f')(d.p75));
      })

    boxes
      .enter()
        .append('rect')
          .attr('class', 'catcher')
          .attr('x', 0)
          .attr('y', d => yScale(d.name))
          .attr('width', chartWidth)
          .attr('height', yScale.bandwidth())
          .attr('opacity', 0)
        .on('mouseover', d => this.highlightBox([d.name], true))
        .on('mouseleave', d => this.highlightBox())

    const axis = svg.selectAll('.axis');
    axis.selectAll('path').style('stroke', colorMedian);
    axis.selectAll('line').style('stroke', colorMedian);
    axis.selectAll('text').style('fill', colorBox).attr('font-size', '12');

    this.setState({ init: true })

  }

  render() {
    const { width, height } = this.state;
    const { title, source, sourceUrl } = this.props;
    const sourceCode = sourceUrl ? <a href={sourceUrl} target="_blank">{source}</a> : source;

    return (
      <StyledBoxPlot innerRef={container => this.container = container} >
      <h4 className="af-title">{title}</h4>
        <svg width={width} height={height} >
          <g className="af-boxplot">
            <g className="x axis" />
            <g className="y axis" />
          </g>
        </svg>
        <div className="af-source">{sourceCode}</div>
      </StyledBoxPlot>
    );
  }
}

export default BoxPlot;



// WEBPACK FOOTER //
// ./src/components/BoxPlot/BoxPlot.js